import { Guid } from '../guid';

export class TaskMapping {
	id = Guid();
	sourceTaskID: string;
	destinationTaskID: string;
	label: string;
	taskName: string;

	constructor(init: Partial<TaskMapping>) {
		if (init.sourceTaskID === undefined) {
			throw new Error('sourceTaskID is a required property');
		}
		if (init.destinationTaskID === undefined) {
			throw new Error('destinationTaskID is a required property');
		}
		if (init.label === undefined) {
			throw new Error('label is a required property');
		}
		this.sourceTaskID = init.sourceTaskID;
		this.destinationTaskID = init.destinationTaskID;
		this.label = init.label;
		this.taskName = init.taskName ?? '';
		Object.assign(this, init);
	}
}
